<div class="dynabot-widget">
  @if (open) {
    <div class="dynabot-panel mat-elevation-z8" role="dialog" aria-label="DynaBot chat">
      <div class="dynabot-header">
        <div class="dynabot-title">
          <mat-icon>smart_toy</mat-icon>
          <span>DynaBot</span>
          <span class="dynabot-prototype-tag">Prototype</span>
        </div>
        <div class="dynabot-header-actions">
          <button mat-icon-button matTooltip="New chat" aria-label="New chat" (click)="resetChat()" [disabled]="!messages.length">
            <mat-icon>refresh</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Close" aria-label="Close DynaBot" (click)="toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="dynabot-prototype-warning" role="note">
        <mat-icon>warning_amber</mat-icon>
        <span><strong>Prototype only.</strong> DynaBot's answers can be wrong or incomplete and must not be relied on for credit or any other decision. Always check the source records.</span>
      </div>

      @if (hasApplication) {
        <div class="dynabot-subheader">
          Application {{ applicationId }}
          @if (contextBuiltAt) {
            <span> · data as at {{ contextBuiltAt | date: 'd MMM, h:mm a' }}</span>
          }
          @if (contextSections.length) {
            <button type="button" class="dynabot-sources-toggle" (click)="toggleSources()">
              {{ sourcesLabel }}
              <mat-icon>{{ showSources ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          }
        </div>
        @if (showSources) {
          <ul class="dynabot-sources">
            @for (source of contextSections; track source.title) {
              <li [class]="'status-' + source.status">
                <mat-icon>{{ sourceIcon(source) }}</mat-icon>
                <span class="source-title">{{ source.title }}</span>
                @if (source.detail) {
                  <span class="source-detail">{{ source.detail }}</span>
                }
              </li>
            }
          </ul>
        }
      }

      <div class="dynabot-messages" #messageList>
        @if (!hasApplication) {
          <div class="dynabot-empty">Open an application to chat about it.</div>
        } @else if (!messages.length) {
          <div class="dynabot-empty">
            Ask anything about this application: credit flow results, KYB, bank statements, documents, or how it measures up against the credit policy.
          </div>
        }
        @for (message of messages; track $index) {
          <div class="dynabot-message" [class.from-user]="message.role === 'user'" [class.from-assistant]="message.role === 'assistant'">
            <div class="dynabot-bubble">{{ message.content }}</div>
          </div>
        }
        @if (pending) {
          <div class="dynabot-pending">
            <mat-spinner diameter="16"></mat-spinner>
            <span>{{ pendingLabel }}</span>
          </div>
        }
        @if (noticeMessage) {
          <div class="dynabot-notice">{{ noticeMessage }}</div>
        }
        @if (errorMessage) {
          <div class="dynabot-error">{{ errorMessage }}</div>
        }
        @if (conversationFull) {
          <div class="dynabot-notice">This chat has reached its limit. Start a new chat to keep going.</div>
        }
      </div>

      <div class="dynabot-input">
        <textarea
          rows="2"
          [formControl]="formControlMessage"
          [attr.maxlength]="maxLength"
          [placeholder]="hasApplication ? 'Ask DynaBot about this application' : 'Open an application first'"
          [readonly]="!hasApplication"
          (keydown)="onKeydown($event)"></textarea>
        <button mat-icon-button color="primary" aria-label="Send" [disabled]="!canSend" (click)="send()">
          <mat-icon>send</mat-icon>
        </button>
      </div>
      <div class="dynabot-footer">Internal use only. DynaBot only sees this application's data and can make mistakes.</div>
    </div>
  }

  <button class="dynabot-bubble-button mat-elevation-z6" [matTooltip]="open ? '' : 'Ask DynaBot'" aria-label="Toggle DynaBot" (click)="toggle()">
    <mat-icon>{{ open ? 'close' : 'smart_toy' }}</mat-icon>
  </button>
</div>
